import Swiper, { Controller, Navigation, Pagination } from 'swiper'

document.addEventListener('DOMContentLoaded', () => {
  const thumbsSlider = document.querySelector('.reviews-thumbs__slider')
  const reviewsSlider = document.querySelector('.reviews-page__swiper')
  const filters = document.querySelector('.reviews-page__filters')
  if (thumbsSlider && reviewsSlider) {
    const prevEl = document.querySelector('.reviews-page__navigation-button.reviews-page__navigation-button--prev')
    const nextEl = document.querySelector('.reviews-page__navigation-button.reviews-page__navigation-button--next')
    const paginationInner = document.querySelector('.reviews-page__inner')
    let thumbsSwiper
    let reviewsSwiper
    const createSliders = () => {
      thumbsSwiper = new Swiper(thumbsSlider, {
        modules: [Controller],
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        init: true,
        allowTouchMove: false,
        slideToClickedSlide: true
      })
      reviewsSwiper = new Swiper(reviewsSlider, {
        modules: [Controller, Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        init: true,
        effect: "creative",
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        navigation: {
          prevEl,
          nextEl,
        },
        pagination: {
          el: '.reviews-page__pagination-list',
          bulletClass: 'reviews-page__pagination pagination__item',
          bulletActiveClass: 'pagination__item--active',
          clickable: true
        },
        breakpoints: {
          999: {
            allowTouchMove: false
          },
          0: {
            allowTouchMove: true
          }
        }
      })
    }
    createSliders()

    const resize = () => {
      filters.style.setProperty('--max-width', `${reviewsSwiper.slides[0].clientWidth}px`)
    }

    window.addEventListener('resize', resize)
    resize()
    thumbsSlider.addEventListener('click', e => {
      if(e.target.closest('.reviews-thumbs__slide')) {
        throttle = true
      }
    })
    let paginations = paginationInner?.querySelectorAll('.reviews-page__pagination')
    if(paginations) {
      paginations[0].classList.remove('pagination__item--active')
      setTimeout(() => {
        paginations[0].classList.add('pagination__item--active')
      })
    }
    reviewsSwiper.controller.control = thumbsSwiper
    thumbsSwiper.controller.control = reviewsSwiper

    let throttle = false
    let timeout
    const startTimeout = () => {
      clearTimeout(timeout)
      if (throttle) {
        timeout = setTimeout(() => {
          throttle = false
          reviewsSwiper.slideNext()
        }, 30000)
      } else {
        timeout = setTimeout(() => {
          reviewsSwiper.slideNext()
        }, 10000)
      }
    }


    reviewsSwiper.on('slideChange', () => {
      startTimeout()
      paginationInner.scrollTo({
        left: paginations[reviewsSwiper.realIndex].offsetLeft,
        behavior: 'smooth'
      })
    })

    reviewsSwiper.on('touchMove', throttle = true)

    prevEl.addEventListener('click', () => throttle = true)
    nextEl.addEventListener('click', () => throttle = true)


    window.updateReviewSlider = () => {
      reviewsSwiper.destroy()
      thumbsSwiper.destroy()
      createSliders()
      reviewsSwiper.controller.control = thumbsSwiper
      thumbsSwiper.controller.control = reviewsSwiper

      paginations = paginationInner?.querySelectorAll('.reviews-page__pagination')
    }

    setTimeout(() => {
      throttle = false
      startTimeout()
    })
  }
})
